
const FlyEngConstants = {
    LEVEL: [{name: "A", age: 0}, {name: "B", age: 1}, {name: "C", age: 2}, {name: "D", age: 3}],
    BOOK : {
        CLASS : {
            TITLE : { // class 권 이름
                'default': ['Book 1', 'Book 2', 'Book 3', 'Book 4', 'Book 5', 'Summer', 'Book 6', 'Book 7', 'Book 8', 'Book 9', 'Book 10', 'Winter'],
                '2021': ['Book 1', 'Book 2', 'Book 3', 'Book 4', 'Book 5', 'Summer', 'Book 6', 'Book 7', 'Book 8', 'Book 9', 'Book 10', 'Winter']
            }
        },
        HOME: {
            'TITLE' : { // home 권 이름
                'default': ['Book 1', 'Book 2', 'Book 3', 'Book 4', 'Book 5', 'Summer', 'Book 6', 'Book 7', 'Book 8', 'Book 9', 'Book 10', 'Winter'],
                '2021': ['Book 1', 'Book 2', 'Book 3', 'Book 4', 'Book 5', 'Summer', 'Book 6', 'Book 7', 'Book 8', 'Book 9', 'Book 10', 'Winter']
            }
        },
    },
    CLASS: {
        CATEGORY : [
            {id: 0, name: '교실영어'}, {id: 1, name: '스페셜'}
        ],
    },
    HOME : {      // 교실영어 활동안 관련 상수
        // 주간 교실영어 활동안은 교실영어 5개, 동화, activity, ai 총 8개로 구성
        'PLAN_ACTIVITY_CATEGORY_ID' : 1,    // 교실영어의 ACTIVITY.AC_ID
        'PLAN_ACTIVITY_STAT_ID' : 0,        // 통계 저장 시 교실영어의 카테고리 ID
        'MONTHLY_MEDAL' : [     // 월별 상장 정보
            {month: 3, name: "기초 튼튼 I"}, {month: 4, name: "기초 튼튼 II"}, {month: 5, name: "기초 튼튼 III"}, {month: 6, name: "중급 튼튼 I"}, {month: 7, name: "중급 튼튼 II"}, 
            {month: 8, name: "중급 튼튼 III"}, {month: 9, name: "중급 튼튼 IV"}, {month: 10, name: "고급 튼튼 I"}, {month: 11, name: "고급 튼튼 II"}, {month: 12, name: "고급 튼튼 III"}, 
            {month: 1, name: "고급 튼튼 IV"}, {month: 2, name: "고급 튼튼 V"}, 
        ],
        'CATEGORY' : [
            {id: 0, name: '교실영어'}, {id: 3, name: '영상'}, {id: 4, name: '동화'}, {id: 5, name: '액티비티'}, {id: 6, name: 'AI'}
        ],
        'EXECUTE_PATH' : [  // 실행 경로
            { id: -1, groupPath: "-", name: "경로없음", sub: [
                { path: "-", name: "경로없음" }
            ]},
            { id: 0, groupPath: "/toweek", name: "금주의 학습", sub: [
                { path: "/toweek", name: "금주의 학습" }, { path: "/toweek/all", name: "금주의 학습-영상 전체" }
            ]},
            { id: 1, groupPath: "/library", name: "도서관", sub: [
                { path: "/library", name: "도서관" }, { path: "/library/all", name: "도서관-영상 전체" }
            ]},
            // { id: 2, groupPath: "/banner", name: "배너", sub: [
            //     { path: "/banner", name: "배너" }
            // ]}, 
            { id: 3, groupPath: "/storage", name: "보관함", sub: [
                { path: "/storage", name: "보관함" },
                { path: "/storage/recently", name: "보관함-최근 본 콘텐츠" }, { path: "/storage/recently/all", name: "보관함-최근 본 콘텐츠-영상 전체" },
                { path: "/storage/downloaded", name: "보관함-다운로드 완료 콘텐츠" }, { path: "/storage/downloaded/all", name: "보관함-다운로드 완료 콘텐츠-영상 전체" }
            ]}
        ]
    }
};

export default FlyEngConstants;